export default {"src":"/_next/static/media/athleta-logo.9a11c5a1.svg","height":62,"width":479,"blurWidth":0,"blurHeight":0};